import { css, type Theme } from "@emotion/react";

import * as animations from "@styles/emotion-styles/animations";
import * as dimensions from "@styles/emotion-styles/dimensions";
import { hexToRgba } from "@styles/emotion-styles/helpers/hexToRgba/hexToRgba";

export const cardWrapper = {
  base: (theme: Theme) => css`
    ${animations.transition()};
    border-radius: ${dimensions.borderRadius};
    background-color: ${theme.surface.level1};
    position: relative;
    display: flex;
    transform-style: flat;
    width: 100%;
  `,
  isResponsive: css`
    @media only screen and (max-width: ${dimensions.phoneMax}) {
      display: block;
    }
  `,
  hasHoverStyle: (theme: Theme) => css`
    &:hover {
      box-shadow: 0 0 4px 0 ${hexToRgba(theme.text.body, 0.25)};
    }
  `,
  hasBorderStyle: (theme: Theme) => css`
    box-shadow: 0 1px 2px 0 ${hexToRgba(theme.text.body, 0.25)};
    border: 1px solid ${theme.separator.base};
  `,
  ds4: css`
    background-color: transparent;
    box-shadow: none;
  `,
  ds4Border: (theme: Theme) => css`
    border: 1px solid ${theme.system.borderBase};
  `,
  ds4Hover: (theme: Theme) => css`
    &:hover {
      border-color: ${theme.system.borderHover};
      box-shadow: none;
    }
  `,
};
